import { render, staticRenderFns } from "./UserLoginHistory.vue?vue&type=template&id=0273c242&scoped=true&"
import script from "./UserLoginHistory.vue?vue&type=script&lang=js&"
export * from "./UserLoginHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserLoginHistory.vue?vue&type=style&index=0&id=0273c242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0273c242",
  null
  
)

component.options.__file = "www/vues/admin/UserLoginHistory.vue"
export default component.exports